import { Injectable } from "@angular/core";
import { throwError, Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
declare var AesUtil: any;
import { ConfigClass } from "./../config";

@Injectable({ providedIn: "root" })
export class ProfileServices {
  // Base url
  baseurl = ConfigClass.getEndpoint;
  token = JSON.parse(sessionStorage.getItem("currentUser"));

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  constructor(private http: HttpClient) {
    this.httpOptions.headers = this.httpOptions.headers.set(
      "Authorization",
      "bearer " + this.token
    );
    this.httpOptions.headers = this.httpOptions.headers.set(
      "Content-Type",
      "application/json"
    );
  }

  GetProfile(): Observable<any> {
    return this.http
      .get<any>(this.baseurl + "/profile", this.httpOptions)
      .pipe(catchError(this.errorHandl));
  }

  changePassword(oldPassword, newPassword): Observable<any> {
    debugger;
    var encryptedDate = this.Encrypt([oldPassword, newPassword]);
    let data = {
      oldPassword: encryptedDate.result[0],
      newPassword: encryptedDate.result[1],
    };
    return this.http
      .put<any>(
        this.baseurl + "/profile/changepassword",
        data,
        this.httpOptions
      )
      .pipe(catchError(this.errorHandl));
  }

  Encrypt(vals) {
    let result: any = [];
    let iv = "ec13170e833d473a0deef8c5e1788cdf"; //CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    let salt = "a2ca229cafbf73d8296e9048541c75a5"; //CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    let passphrase = "0EElojCKeD9KkVG"; //this.generateRandomValue();
    let x = true;
    if (x) {
      let aesUtil = new AesUtil(128, 1000);
      for (let i = 0; i < vals.length; i++) {
        result.push(aesUtil.encrypt(salt, iv, passphrase, vals[i]));
      }
    } else {
      iv = "";
      salt = "";
      passphrase = "";
      for (let i = 0; i < vals.length; i++) {
        result.push(vals[i]);
      }
    }
    return { iv: iv, salt: salt, passphrase: passphrase, result: result };
  }

  forgetPass(name) {
    return this.http
      .put(this.baseurl + "/ext/forgotpassword?username=" + name + "", "")
      .pipe(catchError(this.errorHandl));
  }
  // Error handling
  errorHandl(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
